import * as fromModel from '../../models/';
import { DataService } from '../data.service';
import { RefDataService } from '../ref-data.service';
import * as Highcharts from 'highcharts';
import { Constant } from '../../../../environments/constants';
import { Utils } from '../../../../utils/utils';


export class ChartDataTransformaion {

    // static Highcharts: typeof Highcharts = Highcharts;
    // static options: Highcharts.Options;

    public static getChartSeries(requestParam: fromModel.ChartSeriesReqParam, dataService: DataService, refDataService: RefDataService): fromModel.ChartSeries{
        let chartSeries: fromModel.ChartSeries; 
        switch(requestParam.chartSeriesType){
            case fromModel.CHARTSERIESTYPE.AGE:
                chartSeries = ChartDataTransformaion.getAgeSeries(requestParam, dataService, refDataService);
                break;
            case fromModel.CHARTSERIESTYPE.BALANCEBYTAXSTATUS:
                chartSeries = ChartDataTransformaion.getBalancesByTaxSeries(requestParam, dataService, refDataService);
                break;
            case fromModel.CHARTSERIESTYPE.WITHDRAWALBYTAXSTATUS:
                chartSeries = ChartDataTransformaion.getWithdrawalByTaxSeries(requestParam, dataService, refDataService);
                break;
            case fromModel.CHARTSERIESTYPE.INCOME:
                chartSeries = null;
                break;
            case fromModel.CHARTSERIESTYPE.NETCASHFLOWSBYTEAR:
                chartSeries = ChartDataTransformaion.getNetCashflowsByYearSeries(requestParam, dataService, refDataService);
                break;
        }

        // console.log(requestParam.chartSeriesType + " Series: " + JSON.stringify(chartSeries));
        return chartSeries;
    }
    
    /* Start: Age Series */
    private static getAgeSeries(requestParam: fromModel.ChartSeriesReqParam, dataService: DataService, refDataService: RefDataService) : fromModel.ChartSeries{
        let chartSeries: fromModel.ChartSeries; 
        if(dataService && dataService.appData && dataService.appData.GoalSummary && dataService.appData.GoalSummaryAppliedPlan
           && dataService.appData.GoalSummaryAppliedPlan.startYr && dataService.appData.GoalSummaryAppliedPlan.endYr){
            //ChartDataTransformaion.options.series[]
            let startYr = dataService.appData.GoalSummaryAppliedPlan.startYr;
            let endYr = dataService.appData.GoalSummaryAppliedPlan.endYr;
            let series = [];
            let data = [];
            let cNameAge;
            //let marker = { enabled: false, symbol:"circle", radius: 1, fillColor: 'gray'};
            let marker = { enabled: false, 
                symbol:"circle", 
                radius: 1, 
                fillColor: 'gray', 
                states: { hover: { enabled: false }
            }};

            for(let yr=startYr;yr<=endYr;yr++){
                cNameAge = dataService.getClientNameAge(yr);

                if(dataService.isSecondaryClient()){            
                    data.push({x: Date.UTC(Number(yr), 0, 1), 
                        y: 0, 
                        pName: cNameAge.pName, 
                        pDisplayName: "Client",
                        pAge: cNameAge.pAge, 
                        sName: cNameAge.sName, 
                        sDisplayName: "Spouse",
                        sAge: cNameAge.sAge
                    });
                    } else {
                    data.push({x: Date.UTC(Number(yr), 0, 1), 
                        y: 0, 
                        pName: cNameAge.pName, 
                        pDisplayName: "Client",                        
                        pAge: cNameAge.pAge                       
                    });                    
                    }
                // data.push({
                //     x: Date.UTC(Number(yr), 0, 1),
                //     y: 0
                // });                
            }
            series.push({name: fromModel.CHARTSERIESNAME.Age, type: 'line', color: 'gray', showInLegend: false, lineWidth: 0, data: data, marker: marker});
            chartSeries = {
                chartSeriesType: requestParam.chartSeriesType,
                series: series
            }
        }
        return chartSeries;
    }
    /* End: Age Series */


    /* Start: BalancesByTax Series and WithdrawalByTax series*/
    private static getBalancesByTaxSeries(requestParam: fromModel.ChartSeriesReqParam, dataService: DataService, refDataService: RefDataService) : fromModel.ChartSeries{
        let chartSeries: fromModel.ChartSeries; 
        let yoyCF;
        //if(dataService && dataService.appData && dataService.appData.Plan && dataService.appData.Plan.planResultViewBy && dataService.appData.Plan.planResultViewBy === fromModel.PLANRESULTVIEWBY.FV){
        if(dataService && dataService.appData && dataService.appData.Plan && dataService.getSettingsByCode(fromModel.SETTINGSCODE.PLAN_RESULT_VIEW_BY) && dataService.getSettingsByCode(fromModel.SETTINGSCODE.PLAN_RESULT_VIEW_BY).value === fromModel.PLANRESULTVIEWBY.FV){
            if(dataService.appData.PlanAnalysis && dataService.appData.PlanAnalysis.yoyCashFlows && dataService.appData.PlanAnalysis.yoyCashFlows.length>0){
                    yoyCF = dataService.appData.PlanAnalysis.yoyCashFlows;
            }
        } else {
            if(dataService.appData.PlanAnalysis && dataService.appData.PlanAnalysis.yoyCashFlowsPV && dataService.appData.PlanAnalysis.yoyCashFlowsPV.length>0){
                    yoyCF = dataService.appData.PlanAnalysis.yoyCashFlowsPV;
            }
        }

        if(yoyCF && yoyCF.length>0){
            let series = [];
            let txData = [];    
            let tdData = [];    
            let teData = [];   
            let seriesColor; 
            
            yoyCF.forEach((cf, index) => {
                if(cf && cf.endBalanceByTax && cf.endBalanceByTax && cf.endBalanceByTax.length>0)
                {
                    cf.endBalanceByTax.forEach(balance=> {
                        // if(index === 0){
                        //     const firstYearData = ChartDataTransformaion.prepareBalanceDataForFirstYear(cf, balance.value);
                        //     firstYearData.forEach(fyData => {
                        //         txData.push(fyData);
                        //         tdData.push(fyData);
                        //         teData.push(fyData);                                    
                        //     });
                        // } else {
                        //     if(balance.code === fromModel.TAXSTATUSCODE.TX){
                        //         txData.push(ChartDataTransformaion.prepareBalanceData(cf, balance.value));
                        //     } else if(balance.code === fromModel.TAXSTATUSCODE.TD){
                        //         tdData.push(ChartDataTransformaion.prepareBalanceData(cf, balance.value));
                        //     } else if(balance.code === fromModel.TAXSTATUSCODE.TE){
                        //         teData.push(ChartDataTransformaion.prepareBalanceData(cf, balance.value));
                        //     }                        
                        // }                              
                        if(balance.code === fromModel.TAXSTATUSCODE.TX){
                            txData.push(ChartDataTransformaion.prepareBalanceData(cf, balance.value));
                        } else if(balance.code === fromModel.TAXSTATUSCODE.TD){
                            tdData.push(ChartDataTransformaion.prepareBalanceData(cf, balance.value));
                        } else if(balance.code === fromModel.TAXSTATUSCODE.TE){
                            teData.push(ChartDataTransformaion.prepareBalanceData(cf, balance.value));
                        }
                    });
                }
            });

            if(!requestParam.taxStatus || requestParam.taxStatus === fromModel.TAXSTATUSCODE.ALL){
                    series.push(ChartDataTransformaion.prepareBalanceSeriesByTaxSeriesName(fromModel.CHARTSERIESNAME.TAXEXEMPT, teData, fromModel.TAXSTATUS.TAXEXEMPT, refDataService));
                series.push(ChartDataTransformaion.prepareBalanceSeriesByTaxSeriesName(fromModel.CHARTSERIESNAME.TAXDEFERRED, tdData, fromModel.TAXSTATUS.TAXDEFERRED, refDataService));
                series.push(ChartDataTransformaion.prepareBalanceSeriesByTaxSeriesName(fromModel.CHARTSERIESNAME.TAXABLE, txData, fromModel.TAXSTATUS.TAXABLE, refDataService));
                
                // series.push({name: fromModel.CHARTSERIESNAME.TAXABLE, type: 'area', showInLegend: false, data: txData});
                // series.push({name: fromModel.CHARTSERIESNAME.TAXDEFERRED, type: 'area', showInLegend: false, data: tdData});
                // series.push({name: fromModel.CHARTSERIESNAME.TAXEXEMPT, type: 'area', showInLegend: false, data: teData});
            } else if(requestParam.taxStatus === fromModel.TAXSTATUSCODE.TE){
                series.push(ChartDataTransformaion.prepareBalanceSeriesByTaxSeriesName(fromModel.CHARTSERIESNAME.TAXEXEMPT, teData, fromModel.TAXSTATUS.TAXEXEMPT, refDataService));
            } else if(requestParam.taxStatus === fromModel.TAXSTATUSCODE.TD){
                series.push(ChartDataTransformaion.prepareBalanceSeriesByTaxSeriesName(fromModel.CHARTSERIESNAME.TAXDEFERRED, tdData, fromModel.TAXSTATUS.TAXDEFERRED, refDataService));
            } else if(requestParam.taxStatus === fromModel.TAXSTATUSCODE.TX){
                series.push(ChartDataTransformaion.prepareBalanceSeriesByTaxSeriesName(fromModel.CHARTSERIESNAME.TAXABLE, txData, fromModel.TAXSTATUS.TAXABLE, refDataService));
            }
            
            chartSeries = {
                chartSeriesType: requestParam.chartSeriesType,
                series: series
            }
        }
        return chartSeries;
    }

    private static getWithdrawalByTaxSeries(requestParam: fromModel.ChartSeriesReqParam, dataService: DataService, refDataService: RefDataService) : fromModel.ChartSeries{
        let chartSeries: fromModel.ChartSeries; 
        let yoyCF;

        //if(dataService && dataService.appData && dataService.appData.Plan && dataService.appData.Plan.planResultViewBy && dataService.appData. === fromModel.PLANRESULTVIEWBY.FV){
        if(dataService && dataService.appData && dataService.appData.Plan && dataService.getSettingsByCode(fromModel.SETTINGSCODE.PLAN_RESULT_VIEW_BY) && dataService.getSettingsByCode(fromModel.SETTINGSCODE.PLAN_RESULT_VIEW_BY).value === fromModel.PLANRESULTVIEWBY.FV){
            if(dataService.appData.PlanAnalysis && dataService.appData.PlanAnalysis.yoyCashFlows && dataService.appData.PlanAnalysis.yoyCashFlows.length>0){
                    yoyCF = dataService.appData.PlanAnalysis.yoyCashFlows;
            }
        } else {
            if(dataService.appData.PlanAnalysis && dataService.appData.PlanAnalysis.yoyCashFlowsPV && dataService.appData.PlanAnalysis.yoyCashFlowsPV.length>0){
                    yoyCF = dataService.appData.PlanAnalysis.yoyCashFlowsPV;
            }
        }
        if(yoyCF && yoyCF.length>0){
            let series = [];
            let txData = [];    
            let tdData = [];    
            let teData = [];   
            let seriesColor; 
            
            yoyCF.forEach((cf, index) => {
                if(cf && cf.withdrawalByTax && cf.withdrawalByTax && cf.withdrawalByTax.length>0)
                {
                    cf.withdrawalByTax.forEach(balance=> {
                        // if(index === 0){
                        //     const firstYearData = ChartDataTransformaion.prepareBalanceDataForFirstYear(cf, balance.value);
                        //     firstYearData.forEach(fyData => {
                        //         txData.push(fyData);
                        //         tdData.push(fyData);
                        //         teData.push(fyData);                                    
                        //     });
                        // } else {
                        //     if(balance.code === fromModel.TAXSTATUSCODE.TX){
                        //         txData.push(ChartDataTransformaion.prepareBalanceData(cf, balance.value));
                        //     } else if(balance.code === fromModel.TAXSTATUSCODE.TD){
                        //         tdData.push(ChartDataTransformaion.prepareBalanceData(cf, balance.value));
                        //     } else if(balance.code === fromModel.TAXSTATUSCODE.TE){
                        //         teData.push(ChartDataTransformaion.prepareBalanceData(cf, balance.value));
                        //     }                        
                        // }                              
                        if(balance.code === fromModel.TAXSTATUSCODE.TX){
                            txData.push(ChartDataTransformaion.prepareBalanceData(cf, balance.value));
                        } else if(balance.code === fromModel.TAXSTATUSCODE.TD){
                            tdData.push(ChartDataTransformaion.prepareBalanceData(cf, balance.value));
                        } else if(balance.code === fromModel.TAXSTATUSCODE.TE){
                            teData.push(ChartDataTransformaion.prepareBalanceData(cf, balance.value));
                        }
                    });
                }
            });

            if(!requestParam.taxStatus || requestParam.taxStatus === fromModel.TAXSTATUSCODE.ALL){
                series.push(ChartDataTransformaion.prepareBalanceSeriesByTaxSeriesName(fromModel.CHARTSERIESNAME.TAXEXEMPT, teData, fromModel.TAXSTATUS.TAXEXEMPT, refDataService));
                series.push(ChartDataTransformaion.prepareBalanceSeriesByTaxSeriesName(fromModel.CHARTSERIESNAME.TAXDEFERRED, tdData, fromModel.TAXSTATUS.TAXDEFERRED, refDataService));
                series.push(ChartDataTransformaion.prepareBalanceSeriesByTaxSeriesName(fromModel.CHARTSERIESNAME.TAXABLE, txData, fromModel.TAXSTATUS.TAXABLE, refDataService));
                
                // series.push({name: fromModel.CHARTSERIESNAME.TAXABLE, type: 'area', showInLegend: false, data: txData});
                // series.push({name: fromModel.CHARTSERIESNAME.TAXDEFERRED, type: 'area', showInLegend: false, data: tdData});
                // series.push({name: fromModel.CHARTSERIESNAME.TAXEXEMPT, type: 'area', showInLegend: false, data: teData});
            } else if(requestParam.taxStatus === fromModel.TAXSTATUSCODE.TE){
                series.push(ChartDataTransformaion.prepareBalanceSeriesByTaxSeriesName(fromModel.CHARTSERIESNAME.TAXEXEMPT, teData, fromModel.TAXSTATUS.TAXEXEMPT, refDataService));
            } else if(requestParam.taxStatus === fromModel.TAXSTATUSCODE.TD){
                series.push(ChartDataTransformaion.prepareBalanceSeriesByTaxSeriesName(fromModel.CHARTSERIESNAME.TAXDEFERRED, tdData, fromModel.TAXSTATUS.TAXDEFERRED, refDataService));
            } else if(requestParam.taxStatus === fromModel.TAXSTATUSCODE.TX){
                series.push(ChartDataTransformaion.prepareBalanceSeriesByTaxSeriesName(fromModel.CHARTSERIESNAME.TAXABLE, txData, fromModel.TAXSTATUS.TAXABLE, refDataService));
            }
            
            chartSeries = {
                chartSeriesType: requestParam.chartSeriesType,
                series: series
            }
        }
        return chartSeries;
    }

    private static prepareBalanceData(cf, balance){        
        let data = {x: Date.UTC(Number(cf.yr), 0, 1), y: balance};
        return data;
    }

    private static prepareBalanceDataForFirstYear(cf, balance){        
        let data = [];
        data.push({x: Date.UTC(Number(cf.yr), 0, 1), y: cf.portBeginBal});
        data.push({x: Date.UTC(Number(cf.yr), 5, 1), y: balance});
        return data;
    }

    private static prepareBalanceSeriesByTaxSeriesName(name: fromModel.CHARTSERIESNAME, data, taxStatus: fromModel.TAXSTATUS, refDataService: RefDataService){
        let series;        
        let seriesColor;
        seriesColor = refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Colors,taxStatus.replace('-','').toUpperCase()).value;
        let marker = { enabled: false, symbol:"circle", radius: 8};
        series = {name: name, type: 'area', showInLegend: true, data: data, color: seriesColor, marker: marker};
        return series;
    }
    /* End: BalancesByTax Series */

   /* Start: Get Net Cashflows ByYear Series */ 
    private static getNetCashflowsByYearSeriesData(from, to, weight, color?){
        let data = {
            color: color, 
            from:from,
            to:to,
            weight: weight
        }
        return data;
    }
   
    private static getNetCashflowsByYearSeries(requestParam: fromModel.ChartSeriesReqParam, dataService: DataService, refDataService: RefDataService) : fromModel.ChartSeries{
        let chartSeries: fromModel.ChartSeries; 
        let yoyCF;
        let portEndBal = 0;
        let portBeginBal = 0;
        //if(dataService && dataService.appData && dataService.appData.Plan && dataService.appData. && dataService.appData. === fromModel.PLANRESULTVIEWBY.FV){
        if(dataService && dataService.appData && dataService.appData.Plan && dataService.getSettingsByCode(fromModel.SETTINGSCODE.PLAN_RESULT_VIEW_BY) && dataService.getSettingsByCode(fromModel.SETTINGSCODE.PLAN_RESULT_VIEW_BY).value === fromModel.PLANRESULTVIEWBY.FV){
            if(dataService.appData.PlanAnalysis && dataService.appData.PlanAnalysis.yoyCashFlows && dataService.appData.PlanAnalysis.yoyCashFlows.length>0){
                    yoyCF = dataService.appData.PlanAnalysis.yoyCashFlows;
            }
        } else {
            if(dataService.appData.PlanAnalysis && dataService.appData.PlanAnalysis.yoyCashFlowsPV && dataService.appData.PlanAnalysis.yoyCashFlowsPV.length>0){
                    yoyCF = dataService.appData.PlanAnalysis.yoyCashFlowsPV;
            }
        }

        if(yoyCF && yoyCF.length>0){
            let series = [];
            let data = [];
            //let totalNodes = 0;    
            
            enum NODELABEL {
                "EMPTYSTRING" = "",
                "PORTFOLIOINCOME" = "Portfolio Income",
                "TAXABLEPORTFOLIOINCOME" = "Taxable Portfolio Income",
                "TOTALINCOME" = "Total Income",
                "TOTALEXPENSE" = "Total Expenses",
                "TOTALSAVINGS" = "Total Savings",
                "SURPLUS" = "Surplus",
                "SHORTFALL" = "Shortfall",
                "INCOMETAXES" = "Taxes",
                "PORTFOLIOTAXES" = "Portfolio Taxes",
                "CLIENTRMD" = "Client RMD",
                "SPOUSERMD" = "Spouse RMD",
                "RMDTAXES" = "RMD Taxes", 
                "PORTFOLIOWITHDRAWAL" = "Portfolio Withdrawal",
                "PORTINCOMETAXES" = "Portfolio Income Taxes",
                // "PORTCGTAXES" = "Portfolio CG Taxes",
                // "PORTGLTAXES" = "Portfolio GL",
                // "PORTGL" = "Portfolio GL",
                "PORTWITHDRAWALINCTAX" = "Portfolio Withdrawal Income Taxes",
                "PORTWITHDRAWALCGTAX" = "Portfolio Withdrawal CG Taxes",
                 
            }
            
            if(requestParam.year){
                let yoyCashFlow =  yoyCF.find(cf=>cf.yr === requestParam.year);
                if(yoyCashFlow){

                    //let legacyExpAmount = 0;
                    // if(yoyCashFlow.totExpenseIds && yoyCashFlow.totExpenseIds.length>0){
                    //     yoyCashFlow.totExpenseIds.forEach(exp => {
                    //         const legacyExp = dataService.getExpenseByExpenseId(exp.code);
                    //         if(legacyExp.expType === fromModel.EXPENSETYPE.LGY){
                    //             legacyExpAmount = exp.value;
                    //         }                            
                    //     });
                    // }
                    portEndBal = yoyCashFlow.portEndBal;
                    portBeginBal = yoyCashFlow.portBeginBal
                    let remaningIncome = yoyCashFlow.totIncome;                    
                    let remaningExpense = yoyCashFlow.totExpense;
                    let totalTaxablePortIncome = yoyCashFlow.portInc + yoyCashFlow.c1Rmd + yoyCashFlow.c2Rmd + yoyCashFlow.totWithdrawal;
                    let totalTaxablePortIncomeWithNoRmdTaxes = yoyCashFlow.portTaxes +  yoyCashFlow.cgTaxWtd + yoyCashFlow.incTaxWtd;
                    let totalTaxablePortIncomeWithRmdTaxes = yoyCashFlow.portTaxes + yoyCashFlow.cgTaxWtd + yoyCashFlow.incTaxWtd + yoyCashFlow.rmdTaxes;
                    let remaningTotalTaxablePortIncome = totalTaxablePortIncome - totalTaxablePortIncomeWithRmdTaxes;

                    
                    if(yoyCashFlow.totIncomeIds && yoyCashFlow.totIncomeIds.length>0){
                        yoyCashFlow.totIncomeIds.forEach(inc => {
                            const income = dataService.getIncomeByIncomeId(inc.code);                            
                            let incDesc = income.incDesc;                            
                            //if(income.incType === fromModel.INCOMETYPE.SS || income.incType === fromModel.INCOMETYPE.EI || income.incType === fromModel.INCOMETYPE.SE){
                                const incOwner = dataService.getClientByClientId(income.owner);
                                if(incOwner){
                                    incDesc = `${incDesc} (${incOwner.LegalEntityName})`;
                                }
                            //}
                            
                            data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(incDesc, NODELABEL.TOTALINCOME, inc.value));
                        });
                    }
                    

                    if(yoyCashFlow.totTax){
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(NODELABEL.TOTALINCOME, NODELABEL.INCOMETAXES, yoyCashFlow.totTax));
                    }
                    if(yoyCashFlow.totSavings){
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(NODELABEL.TOTALINCOME, NODELABEL.TOTALSAVINGS, yoyCashFlow.totSavings));                    
                    }
                    remaningIncome = remaningIncome - (yoyCashFlow.totTax + yoyCashFlow.totSavings);

                    if(dataService.getClientByRole(fromModel.CLIENTROLE.Primary) && yoyCashFlow.c1Rmd){
                        let rmdClient = `RMD (${dataService.getClientByRole(fromModel.CLIENTROLE.Primary).clientname})`;
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(rmdClient, NODELABEL.TAXABLEPORTFOLIOINCOME, yoyCashFlow.c1Rmd)); 
                    }

                    if(dataService.isSecondaryClient() && yoyCashFlow.c2Rmd){
                        let rmdSpouse = `RMD (${dataService.getClientByRole(fromModel.CLIENTROLE.Secondary).clientname})`;
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(rmdSpouse, NODELABEL.TAXABLEPORTFOLIOINCOME, yoyCashFlow.c2Rmd)); 
                    }

                    if(yoyCashFlow.portInc){
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(NODELABEL.PORTFOLIOINCOME, NODELABEL.TAXABLEPORTFOLIOINCOME, yoyCashFlow.portInc));                     
                    }

                    if(yoyCashFlow.totWithdrawal){
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(NODELABEL.PORTFOLIOWITHDRAWAL, NODELABEL.TAXABLEPORTFOLIOINCOME, yoyCashFlow.totWithdrawal));                         
                    }

                    if(remaningIncome>=remaningExpense){ //income is more than expense
                        if(remaningExpense){
                            data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(NODELABEL.TOTALINCOME, NODELABEL.TOTALEXPENSE, remaningExpense));
                            remaningIncome = remaningIncome - remaningExpense;
                            remaningExpense = 0;
                        }
                    } else { //expense is more than income
                        if(remaningIncome){
                            data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(NODELABEL.TOTALINCOME, NODELABEL.TOTALEXPENSE, remaningIncome));
                            remaningExpense = remaningExpense - remaningIncome;                        
                            remaningIncome = 0;
                        }
                    }

                    if(remaningTotalTaxablePortIncome>=remaningExpense){ //taxable portfolio income is more than expense
                        if(remaningExpense){
                            data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(NODELABEL.TAXABLEPORTFOLIOINCOME, NODELABEL.TOTALEXPENSE, remaningExpense));                        
                            remaningTotalTaxablePortIncome = remaningTotalTaxablePortIncome - remaningExpense;
                            remaningExpense = 0;
                        }
                    } else { //expense is more than taxable portfolio income
                        if(remaningTotalTaxablePortIncome){
                            data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(NODELABEL.TAXABLEPORTFOLIOINCOME, NODELABEL.TOTALEXPENSE, remaningTotalTaxablePortIncome));
                            remaningExpense = remaningExpense - remaningTotalTaxablePortIncome;                        
                            remaningTotalTaxablePortIncome = 0;
                        }                        
                    }

                    if(yoyCashFlow.rmdTaxes){
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(NODELABEL.TAXABLEPORTFOLIOINCOME, NODELABEL.RMDTAXES, yoyCashFlow.rmdTaxes));
                    }

                    if(totalTaxablePortIncomeWithNoRmdTaxes){
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(NODELABEL.TAXABLEPORTFOLIOINCOME, NODELABEL.PORTFOLIOTAXES, totalTaxablePortIncomeWithNoRmdTaxes));                    
                    }

                    if(remaningIncome){
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(NODELABEL.TOTALINCOME, NODELABEL.SURPLUS, remaningIncome, '#65803b'));
                    }

                    if(remaningTotalTaxablePortIncome){                        
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(NODELABEL.TAXABLEPORTFOLIOINCOME, NODELABEL.SURPLUS, remaningTotalTaxablePortIncome, '#65803b'));
                    }
                    
                    if(remaningExpense){
                        if(yoyCashFlow.totIncome || totalTaxablePortIncome){
                            data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(NODELABEL.EMPTYSTRING, NODELABEL.SHORTFALL, 0 ));
                        }
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(NODELABEL.SHORTFALL, NODELABEL.TOTALEXPENSE, remaningExpense, '#F24405'));                    
                    }

                    if(yoyCashFlow.totExpenseIds && yoyCashFlow.totExpenseIds.length>0){
                        yoyCashFlow.totExpenseIds.forEach(exp => {
                            const _exp = dataService.getExpenseByExpenseId(exp.code);
                            if(_exp && _exp.expType !== fromModel.EXPENSETYPE.LGY){
                                const expDesc = dataService.getExpenseByExpenseId(exp.code).expDesc;
                                data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(NODELABEL.TOTALEXPENSE, expDesc, exp.value));                                
                            }
                        });
                    }

                    if(yoyCashFlow.portTaxes){                        
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(NODELABEL.PORTFOLIOTAXES, NODELABEL.PORTINCOMETAXES, yoyCashFlow.portTaxes));                        
                    }
                     
                    // if(yoyCashFlow.cgTaxes){                        
                    //     data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(NODELABEL.PORTFOLIOTAXES, NODELABEL.PORTCGTAXES, yoyCashFlow.cgTaxes));
                    // }
                    if(yoyCashFlow.cgTaxWtd){                        
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(NODELABEL.PORTFOLIOTAXES, NODELABEL.PORTWITHDRAWALINCTAX, yoyCashFlow.cgTaxWtd));
                    }
                    if(yoyCashFlow.incTaxWtd){                        
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(NODELABEL.PORTFOLIOTAXES, NODELABEL.PORTWITHDRAWALCGTAX, yoyCashFlow.incTaxWtd));
                    }
                    
                
                    //let seriesColor = [];
                    series = [{
                        name: '',
                        data: data,
                        // color: seriesColor,
                        //Review Start
                        type: 'sankey', 
                        // dataLabels: {
                        //  nodeFormat:   '{point.name}: ${point.sum:,.0f}',  
                        //  style: {
                        //      fontSize: '14',
                        //      color: '#353459',                                
                        //      textOutline: 'none'       
                        //  }
                        // },
                        //Review End
                    }];
                }
            }
            let lifeEvents = dataService.getLifeEventArray();
            let c1RetYear;
            let c2RetYear;
            let retLE;
            
            retLE = lifeEvents.find(le=>le.lifeEventCd === 'RET' && le.clientId===dataService.getClientByRole(fromModel.CLIENTROLE.Primary).clientid);
            if(retLE){
                c1RetYear = retLE.yr; 
            }

            if(dataService.isSecondaryClient()){
                retLE = lifeEvents.find(le=>le.lifeEventCd === 'RET' && le.clientId===dataService.getClientByRole(fromModel.CLIENTROLE.Secondary).clientid);
                if(retLE){
                    c2RetYear = retLE.yr; 
                }
            }

            let nCFAdditionalOutput:fromModel.NetCashFlowOutput = {
                portEndBal: portEndBal,
                portBeginBal: portBeginBal,
                c1RetYear: c1RetYear,
                c2RetYear: c2RetYear
            }
            chartSeries = {
                chartSeriesType: requestParam.chartSeriesType,
                series: series,
                portfolioValue: portEndBal,
                nCFAdditionalOutput: nCFAdditionalOutput
            }
        }
        return chartSeries;
    }
 
    private static getNetCashflowsByYearSeriesOld(requestParam: fromModel.ChartSeriesReqParam, dataService: DataService, refDataService: RefDataService) : fromModel.ChartSeries{
        let chartSeries: fromModel.ChartSeries; 
        let yoyCF;
        //if(dataService && dataService.appData && dataService.appData.Plan && dataService.appData.Plan.planResultViewBy && dataService.appData.Plan.planResultViewBy === fromModel.PLANRESULTVIEWBY.FV){
        if(dataService && dataService.appData && dataService.appData.Plan && dataService.getSettingsByCode(fromModel.SETTINGSCODE.PLAN_RESULT_VIEW_BY) && dataService.getSettingsByCode(fromModel.SETTINGSCODE.PLAN_RESULT_VIEW_BY).value === fromModel.PLANRESULTVIEWBY.FV){
            if(dataService.appData.PlanAnalysis && dataService.appData.PlanAnalysis.yoyCashFlows && dataService.appData.PlanAnalysis.yoyCashFlows.length>0){
                    yoyCF = dataService.appData.PlanAnalysis.yoyCashFlows;
            }
        } else {
            if(dataService.appData.PlanAnalysis && dataService.appData.PlanAnalysis.yoyCashFlowsPV && dataService.appData.PlanAnalysis.yoyCashFlowsPV.length>0){
                    yoyCF = dataService.appData.PlanAnalysis.yoyCashFlowsPV;
            }
        }

        if(yoyCF && yoyCF.length>0){
            let series = [];
            let data = [];
            //let totalNodes = 0;
            
            if(requestParam.year){
                let yoyCashFlow =  yoyCF.find(cf=>cf.yr === requestParam.year);
                if(yoyCashFlow){
                    

                    if(yoyCashFlow.totIncomeIds && yoyCashFlow.totIncomeIds.length>0){
                        yoyCashFlow.totIncomeIds.forEach(inc => {
                            
                            let incDesc = "Income";
                            const _inc = dataService.getIncomeByIncomeId(inc.code);                            
                            if(_inc){
                                incDesc = _inc.incDesc
                            }
                            data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(incDesc, 'Total Income', inc.value));
                        });
                    }
                    data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('Total Income', 'Taxes', yoyCashFlow.totTax));
                    data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('Total Income', 'Savings', yoyCashFlow.totSavings));                    
                    let incBalance = yoyCashFlow.totIncome - (yoyCashFlow.totTax+ yoyCashFlow.totSavings);
                    if(yoyCashFlow.netCashFlow>=0){                 
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('Total Income', 'Total Expenses', yoyCashFlow.totExpense));
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('Total Income', 'Surplus', yoyCashFlow.netCashFlow));
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('', 'Portfolio', 0));
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('Portfolio', 'Surplus', yoyCashFlow.portEndBal));
                    } else {                        
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('Total Income', 'Total Expenses', incBalance));
                        
                        let remainingExpenses =  yoyCashFlow.totExpense-incBalance; 
                        if(yoyCashFlow.portEndBal>=remainingExpenses){                            
                            data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('', 'Portfolio', 0));
                            data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('Portfolio', 'Total Expenses', remainingExpenses));
                            let surplus = yoyCashFlow.portEndBal - remainingExpenses;
                            data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('Portfolio', 'Surplus', surplus, '#e2f7bf'));
                        } else {
                            data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('', 'Portfolio', 0));
                            data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('Portfolio', 'Total Expenses', yoyCashFlow.portEndBal));
                            data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('', 'Shortfall', 0));
                            data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('Shortfall', 'Total Expenses', yoyCashFlow.totExpense-(yoyCashFlow.portEndBal + incBalance),'#F24405'));
                        }
                    }
                    
                    if(yoyCashFlow.totExpenseIds && yoyCashFlow.totExpenseIds.length>0){
                        yoyCashFlow.totExpenseIds.forEach(exp => {
                            let expDesc = dataService.getExpenseByExpenseId(exp.code).expDesc;
                            data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('Total Expenses', expDesc, exp.value));                            
                        });
                    }
                    //let seriesColor = [];
                    series = [{
                        name: '',
                        data: data,
                        // color: seriesColor,
                        //Review Start
                        type: 'sankey', 
                        // dataLabels: {
                        //     nodeFormat:   '{point.name}: ${point.sum:,.0f}',  
                        //     style: {
                        //         fontSize: '14',
                        //         color: '#353459',                                
                        //         textOutline: 'none'       
                        //     }
                        // },
                        //Review End
                    }];
                }
            }
            
            
            chartSeries = {
                chartSeriesType: requestParam.chartSeriesType,
                series: series
            }
        }
        return chartSeries;
    }

    private static getNetCashflowsByYearSeriesNew(requestParam: fromModel.ChartSeriesReqParam, dataService: DataService, refDataService: RefDataService) : fromModel.ChartSeries{
        let chartSeries: fromModel.ChartSeries; 
        let yoyCF;
        //if(dataService && dataService.appData && dataService.appData.Plan && dataService.appData.Plan.planResultViewBy && dataService.appData.Plan.planResultViewBy === fromModel.PLANRESULTVIEWBY.FV){
        if(dataService && dataService.appData && dataService.appData.Plan && dataService.getSettingsByCode(fromModel.SETTINGSCODE.PLAN_RESULT_VIEW_BY) && dataService.getSettingsByCode(fromModel.SETTINGSCODE.PLAN_RESULT_VIEW_BY).value === fromModel.PLANRESULTVIEWBY.FV){
            if(dataService.appData.PlanAnalysis && dataService.appData.PlanAnalysis.yoyCashFlows && dataService.appData.PlanAnalysis.yoyCashFlows.length>0){
                    yoyCF = dataService.appData.PlanAnalysis.yoyCashFlows;
            }
        } else {
            if(dataService.appData.PlanAnalysis && dataService.appData.PlanAnalysis.yoyCashFlowsPV && dataService.appData.PlanAnalysis.yoyCashFlowsPV.length>0){
                    yoyCF = dataService.appData.PlanAnalysis.yoyCashFlowsPV;
            }
        }

        if(yoyCF && yoyCF.length>0){
            let series = [];
            let data = [];
            //let totalNodes = 0;
            const PORTFOLIOINCOME = "Portfolio Income";
            const TOTALINCOME = "Total Income";
            const TOTALEXPENSE = "Total Expenses";
            const TOTALSAVING = "Total Savings";
            const SURPLUS = "Surplus";
            const SHORTFALL = "Shortfall";
            
            if(requestParam.year){
                let yoyCashFlow =  yoyCF.find(cf=>cf.yr === requestParam.year);
                if(yoyCashFlow){
                    
                    let totalIncome = yoyCashFlow.totIncome + yoyCashFlow.totSavings;
                    let totalExpense =  yoyCashFlow.totExpense + yoyCashFlow.totTax;
                    let remaningExpense = (totalExpense-totalIncome)>0?totalExpense-totalIncome:0;
                    let remaningIncome = (totalIncome-totalExpense)>0?totalIncome-totalExpense:0;
                    

                    if(yoyCashFlow.totIncomeIds && yoyCashFlow.totIncomeIds.length>0){
                        yoyCashFlow.totIncomeIds.forEach(inc => {
                            let incDesc = dataService.getIncomeByIncomeId(inc.code).incDesc;
                            data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(incDesc, TOTALINCOME, inc.value));
                        });
                    }
                    // if(yoyCashFlow.totSavingsIds && yoyCashFlow.totSavingsIds.length>0){
                    //     yoyCashFlow.totSavingsIds.forEach(sav => {
                    //         let savDesc = dataService.getSavingById(sav.code).savDesc;
                    //         data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(savDesc, TOTALINCOME, sav.value));
                    //     });
                    // }

                    data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(TOTALSAVING, TOTALINCOME, yoyCashFlow.totSavings));                    

                    if(totalIncome>=totalExpense){
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(TOTALINCOME, TOTALEXPENSE, totalExpense));
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(TOTALINCOME, SURPLUS, remaningIncome));
                        
                    } else {
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(TOTALINCOME, TOTALEXPENSE, totalIncome));
                    }
                    
                    if(remaningExpense>0 && yoyCashFlow.portEndBal<=remaningExpense){
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('', PORTFOLIOINCOME, 0));
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(PORTFOLIOINCOME, TOTALEXPENSE, yoyCashFlow.portEndBal));
                        let shortfall = remaningExpense - yoyCashFlow.portEndBal;                        
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('', SHORTFALL, 0));
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(SHORTFALL, TOTALEXPENSE, shortfall, '#F24405'));
                    } else {
                        let surplus = yoyCashFlow.portEndBal - remaningExpense;
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('', PORTFOLIOINCOME, 0));
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(PORTFOLIOINCOME, TOTALEXPENSE, remaningExpense));
                        data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData(PORTFOLIOINCOME, SURPLUS, surplus, '#e2f7bf'));
                    }
                    
                    // if(yoyCashFlow.netCashFlow>=0){                 
                    //     data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('Total Income', 'Total Expenses', yoyCashFlow.totExpense));
                    //     data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('Total Income', 'Surplus', yoyCashFlow.netCashFlow));
                    //     data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('', 'Portfolio', 0));
                    //     data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('Portfolio', 'Surplus', yoyCashFlow.portEndBal));
                    // } else {                        
                    //     data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('Total Income', 'Total Expenses', incBalance));
                        
                    //     let remainingExpenses =  yoyCashFlow.totExpense-incBalance; 
                    //     if(yoyCashFlow.portEndBal>=remainingExpenses){                            
                    //         data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('', 'Portfolio', 0));
                    //         data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('Portfolio', 'Total Expenses', remainingExpenses));
                    //         let surplus = yoyCashFlow.portEndBal - remainingExpenses;
                    //         data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('Portfolio', 'Surplus', surplus, '#e2f7bf'));
                    //     } else {
                    //         data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('', 'Portfolio', 0));
                    //         data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('Portfolio', 'Total Expenses', yoyCashFlow.portEndBal));
                    //         data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('', 'Shortfall', 0));
                    //         data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('Shortfall', 'Total Expenses', yoyCashFlow.totExpense-(yoyCashFlow.portEndBal + incBalance),'#F24405'));
                    //     }
                    // }
                    data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('Total Expenses', 'Taxes', yoyCashFlow.totTax));
                    if(yoyCashFlow.totExpenseIds && yoyCashFlow.totExpenseIds.length>0){
                        yoyCashFlow.totExpenseIds.forEach(exp => {
                            let expDesc = dataService.getExpenseByExpenseId(exp.code).expDesc;
                            data.push(ChartDataTransformaion.getNetCashflowsByYearSeriesData('Total Expenses', expDesc, exp.value));                            
                        });
                    }
                    //let seriesColor = [];
                    series = [{
                        name: '',
                        data: data,
                        //color: seriesColor,
                        type: 'sankey', 
                        // dataLabels: {
                        //     nodeFormat:   '{point.name}: ${point.sum:,.0f}',  
                        //     style: {
                        //         fontSize: '14'
                        //     }
                        // },
                    }];
                }
            }
            
            
            chartSeries = {
                chartSeriesType: requestParam.chartSeriesType,
                series: series
            }
        }
        return chartSeries;
    }

    private static getNetCashflowsByYearSeriesBackup(requestParam: fromModel.ChartSeriesReqParam, dataService: DataService, refDataService: RefDataService) : fromModel.ChartSeries{
        let chartSeries: fromModel.ChartSeries; 
        let yoyCF;
        //if(dataService && dataService.appData && dataService.appData.Plan && dataService.appData.Plan.planResultViewBy && dataService.appData.Plan.planResultViewBy === fromModel.PLANRESULTVIEWBY.FV){
        if(dataService && dataService.appData && dataService.appData.Plan && dataService.getSettingsByCode(fromModel.SETTINGSCODE.PLAN_RESULT_VIEW_BY) && dataService.getSettingsByCode(fromModel.SETTINGSCODE.PLAN_RESULT_VIEW_BY).value === fromModel.PLANRESULTVIEWBY.FV){
            if(dataService.appData.PlanAnalysis && dataService.appData.PlanAnalysis.yoyCashFlows && dataService.appData.PlanAnalysis.yoyCashFlows.length>0){
                    yoyCF = dataService.appData.PlanAnalysis.yoyCashFlows;
            }
        } else {
            if(dataService.appData.PlanAnalysis && dataService.appData.PlanAnalysis.yoyCashFlowsPV && dataService.appData.PlanAnalysis.yoyCashFlowsPV.length>0){
                    yoyCF = dataService.appData.PlanAnalysis.yoyCashFlowsPV;
            }
        }

        if(yoyCF && yoyCF.length>0){
            let series = [];
            let keys: ['from', 'to', 'weight','color'];
            let txData = [];    
            let tdData = [];    
            let teData = [];   
            let seriesColor; 
            let data = [];

           
            // series: [{
            //     keys: ['from', 'to', 'weight'],
            //     data: [
            //          ['Salary', 'Total Income', 150000],
            //         ['Secured Income', 'Total Income', 200000],
            //         ['Other Income', 'Total Income', 50000],
            //         ['Total Income', 'Housing', 50000],
            //         ['Total Income', 'Transportation', 10000],
            //         ['Total Income', 'Healthcare', 20000],
            //         ['Total Income', 'Insurance Preminums', 10000],
            //         ['Total Income', 'Personal Expenses', 5000],
            //         ['Total Income', 'Groceries', 5000],
            //         ['Total Income', 'Eating Out', 2500],
            //         ['Total Income', 'Travel', 2500],
            //         ['Total Income', 'Entertainment', 5000],
            //         ['Total Income', 'Other', 290000],
            //         ['Other Expense', 'Other', 10000]
            //     ],
            //     type: 'sankey',
            //     name: 'Sankey demo series'
            // }]
            
            if(requestParam.year){
                let yoyCashFlow =  yoyCF.find(cf=>cf.yr === requestParam.year);
                if(yoyCashFlow){
                    

                    if(yoyCashFlow.totIncomeIds && yoyCashFlow.totIncomeIds.length>0){
                        yoyCashFlow.totIncomeIds.forEach(inc => {
                            let incDesc = dataService.getIncomeByIncomeId(inc.code).incDesc;
                            data.push([incDesc, 'Total Income', inc.value]);
                        });
                    }
                    data.push(['Total Income', 'Taxes', yoyCashFlow.totTax]);
                    data.push(['Total Income', 'Savings', yoyCashFlow.totSavings]);                    
                    let incBalance = yoyCashFlow.totIncome - (yoyCashFlow.totTax+ yoyCashFlow.totSavings);
                    if(yoyCashFlow.netCashFlow>=0){                 
                        data.push(['Total Income', 'Total Expenses', yoyCashFlow.totExpense]);                    
                        data.push(['Total Income', 'Surplus', yoyCashFlow.netCashFlow]);
                        data.push(['', 'Portfolio', 0]);      
                        data.push(['Portfolio', 'Surplus', yoyCashFlow.portEndBal]);   
                    } else {                        
                        data.push(['Total Income', 'Total Expenses', incBalance]);                    
                        // data.push(['', 'Portfolio', yoyCashFlow.portEndBal]);      
                        let remainingExpenses =  yoyCashFlow.totExpense-incBalance; 
                        if(yoyCashFlow.portEndBal>=remainingExpenses){                            
                            data.push(['', 'Portfolio', 0]);  
                            data.push(['Portfolio', 'Total Expenses', remainingExpenses]); 
                            let surplus = yoyCashFlow.portEndBal - remainingExpenses;
                            data.push(['Portfolio', 'Surplus', surplus]);
                        } else {
                            data.push(['', 'Portfolio', 0]);  
                            data.push(['Portfolio', 'Total Expenses', yoyCashFlow.portEndBal]); 
                            data.push(['', 'Shortfall', 0]);      
                            data.push(['Shortfall', 'Total Expenses', yoyCashFlow.totExpense-(yoyCashFlow.portEndBal + incBalance),"#BB0000"]);   
                        }
                    }
                    
                    if(yoyCashFlow.totExpenseIds && yoyCashFlow.totExpenseIds.length>0){
                        yoyCashFlow.totExpenseIds.forEach(exp => {
                            let expDesc = dataService.getExpenseByExpenseId(exp.code).expDesc;
                            data.push(['Total Expenses', expDesc, exp.value]);
                        });
                    }
                    // data.push(['Expenses', 'Housing', 50000]);
                    // data.push(['Expenses', 'Transportation', 10000]);
                    // data.push(['Expenses', 'Healthcare', 20000]);
                    // data.push(['Expenses', 'Insurance Preminums', 10000]);
                    // data.push(['Expenses', 'Personal Expenses', 5000]);
                    // data.push(['Expenses', 'Groceries', 5000]);
                    // data.push(['Expenses', 'Eating Out', 2500]);
                    // data.push(['Expenses', 'Travel', 2500]);
                    // data.push(['Expenses', 'Entertainment', 5000]);
                    // data.push(['Expenses', 'Other', 140000]);
                    //data.push(['Portfolio', 'Total Expenses', yoyCashFlow.portEndBal-yoyCashFlow.totExpense]);                    
                                    
                    // data.push(['Expenses', 'Other', 10000]);
                    series = [{
                        name: '',
                        keys: ['from', 'to', 'weight'],
                        data: data,
                        type: 'sankey', 
                        dataLabels: {
                            nodeFormat:   '{point.name}: ${point.sum:,.0f}',  
                            style: {
                                fontSize: '14'
                            }
                        },
                    }];
                }
            }
            // yoyCF.forEach((cf, index) => {
            //     if(cf && cf.endBalanceByTax && cf.endBalanceByTax && cf.endBalanceByTax.length>0)
            //     {
            //         cf.endBalanceByTax.forEach(balance=> {
            //             // if(index === 0){
            //             //     const firstYearData = ChartDataTransformaion.prepareBalanceDataForFirstYear(cf, balance.value);
            //             //     firstYearData.forEach(fyData => {
            //             //         txData.push(fyData);
            //             //         tdData.push(fyData);
            //             //         teData.push(fyData);                                    
            //             //     });
            //             // } else {
            //             //     if(balance.code === fromModel.TAXSTATUSCODE.TX){
            //             //         txData.push(ChartDataTransformaion.prepareBalanceData(cf, balance.value));
            //             //     } else if(balance.code === fromModel.TAXSTATUSCODE.TD){
            //             //         tdData.push(ChartDataTransformaion.prepareBalanceData(cf, balance.value));
            //             //     } else if(balance.code === fromModel.TAXSTATUSCODE.TE){
            //             //         teData.push(ChartDataTransformaion.prepareBalanceData(cf, balance.value));
            //             //     }                        
            //             // }                              
            //             if(balance.code === fromModel.TAXSTATUSCODE.TX){
            //                 txData.push(ChartDataTransformaion.prepareBalanceData(cf, balance.value));
            //             } else if(balance.code === fromModel.TAXSTATUSCODE.TD){
            //                 tdData.push(ChartDataTransformaion.prepareBalanceData(cf, balance.value));
            //             } else if(balance.code === fromModel.TAXSTATUSCODE.TE){
            //                 teData.push(ChartDataTransformaion.prepareBalanceData(cf, balance.value));
            //             }
            //         });
            //     }
            // });

            // if(!requestParam.taxStatus || requestParam.taxStatus === fromModel.TAXSTATUSCODE.ALL){
            //         series.push(ChartDataTransformaion.prepareBalanceSeriesByTaxSeriesName(fromModel.CHARTSERIESNAME.TAXEXEMPT, teData, fromModel.TAXSTATUS.TAXEXEMPT, refDataService));
            //     series.push(ChartDataTransformaion.prepareBalanceSeriesByTaxSeriesName(fromModel.CHARTSERIESNAME.TAXDEFERRED, tdData, fromModel.TAXSTATUS.TAXDEFERRED, refDataService));
            //     series.push(ChartDataTransformaion.prepareBalanceSeriesByTaxSeriesName(fromModel.CHARTSERIESNAME.TAXABLE, txData, fromModel.TAXSTATUS.TAXABLE, refDataService));
                
            //     // series.push({name: fromModel.CHARTSERIESNAME.TAXABLE, type: 'area', showInLegend: false, data: txData});
            //     // series.push({name: fromModel.CHARTSERIESNAME.TAXDEFERRED, type: 'area', showInLegend: false, data: tdData});
            //     // series.push({name: fromModel.CHARTSERIESNAME.TAXEXEMPT, type: 'area', showInLegend: false, data: teData});
            // } else if(requestParam.taxStatus === fromModel.TAXSTATUSCODE.TE){
            //     series.push(ChartDataTransformaion.prepareBalanceSeriesByTaxSeriesName(fromModel.CHARTSERIESNAME.TAXEXEMPT, teData, fromModel.TAXSTATUS.TAXEXEMPT, refDataService));
            // } else if(requestParam.taxStatus === fromModel.TAXSTATUSCODE.TD){
            //     series.push(ChartDataTransformaion.prepareBalanceSeriesByTaxSeriesName(fromModel.CHARTSERIESNAME.TAXDEFERRED, tdData, fromModel.TAXSTATUS.TAXDEFERRED, refDataService));
            // } else if(requestParam.taxStatus === fromModel.TAXSTATUSCODE.TX){
            //     series.push(ChartDataTransformaion.prepareBalanceSeriesByTaxSeriesName(fromModel.CHARTSERIESNAME.TAXABLE, txData, fromModel.TAXSTATUS.TAXABLE, refDataService));
            // }
            
            chartSeries = {
                chartSeriesType: requestParam.chartSeriesType,
                series: series
            }
        }
        return chartSeries;
    }
    /* End: Get Net Cashflows ByYear Series */ 
}